import {
  PARSING_RESUME,
  PARSING_RESUME_SUCCESSFUL,
  PARSING_RESUME_FAILED,
    CHECK_DUPLICATE_CANDIDATE,
  CHECK_DUPLICATE_CANDIDATE_SUCCESSFUL,
  CHECK_DUPLICATE_CANDIDATE_FAILED,
  ADD_CANDIDATE,
  ADD_CANDIDATE_SUCCESSFUL,
  ADD_CANDIDATE_FAILED,
  UPDATE_CANDIDATE,
  UPDATE_CANDIDATE_FAILED,
  UPDATE_CANDIDATE_SUCCESSFUL,
  GET_CANDIDATE_DATA,
  GET_CANDIDATE_DATA_SUCCESSFUL,
  GET_CANDIDATE_DATA_FAILED,
  GET_NATIONALITY,
  GET_NATIONALITY_FAILED,
  GET_NATIONALITY_SUCCESSFUL,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILED,
  GET_STATE,
  GET_STATE_SUCCESS,
  GET_STATE_FAILED,
  CANDIDATE_GET_IP_LOCATION,
  CANDIDATE_GET_IP_LOCATION_FAILED,
  CANDIDATE_GET_IP_LOCATION_SUCCESSFULL,
  PERMANENT_GET_STATE,
  PERMANENT_GET_STATE_FAILED,
  PERMANENT_GET_STATE_SUCCESS,
  GET_QUALIFICATION_STATE,
  GET_QUALIFICATION_STATE_SUCCESS,
  GET_QUALIFICATION_STATE_FAILED,
  GET_STATE_AND_COUNTRY_DETAILS,GET_STATE_AND_COUNTRY_DETAILS_SUCCESS,GET_STATE_AND_COUNTRY_DETAILS_FAIL,
  GET_SECONDARY_STATE_AND_COUNTRY_DETAILS,GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_SUCCESS,GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_FAIL
} from "./actionTypes"

export const parsingResume = user => {
  return {
    type: PARSING_RESUME,
    payload: { user },
  }
}

export const parsingResumeSuccessful = user => {
  return {
    type: PARSING_RESUME_SUCCESSFUL,
    payload: user,
  }
}

export const parsingResumeFailed = user => {
  return {
    type: PARSING_RESUME_FAILED,
    payload: user,
  }
}
export const checkDuplicates = duplicateCandidate => {
  return {
    type: CHECK_DUPLICATE_CANDIDATE,
    payload: { duplicateCandidate },
  }
}

export const checkDuplicatesSuccessful = duplicateCandidate => {
  return {
    type: CHECK_DUPLICATE_CANDIDATE_SUCCESSFUL,
    payload: duplicateCandidate,
  }
}

export const checkDuplicatesFailed = duplicateCandidate => {
  return {
    type: CHECK_DUPLICATE_CANDIDATE_FAILED,
    payload: duplicateCandidate,
  }
}


export const addNewCandidates = user => {
  return {
    type: ADD_CANDIDATE,
    payload: { user },
  }
}

export const addCandidateSuccessful = user => {
  return {
    type: ADD_CANDIDATE_SUCCESSFUL,
    payload: user,
  }
}

export const addCandidateFailed = user => {
  return {
    type: ADD_CANDIDATE_FAILED,
    payload: user,
  }
}
export const UpdateCandidates = user => {
  return {
    type: UPDATE_CANDIDATE,
    payload: { user },
  }
}

export const UpdateCandidateSuccessful = user => {
  return {
    type: UPDATE_CANDIDATE_SUCCESSFUL,
    payload: user,
  }
}

export const UpdateCandidateFailed = user => {
  return {
    type: UPDATE_CANDIDATE_FAILED,
    payload: user,
  }
}
export const getCandidateData = user => {
  return {
    type: GET_CANDIDATE_DATA,
    payload: { user },
  }
}

export const getCandidateDataSuccessful = user => {
 
  return {
    type: GET_CANDIDATE_DATA_SUCCESSFUL,
    payload: user,
  }
}

export const getCandidateDataFailed = user => {
  return {
    type: GET_CANDIDATE_DATA_FAILED,
    payload: user,
  }
}
//get Nationality
export const getNationalityData = (user) => {
  return {
    type: GET_NATIONALITY,
    payload:  {user} ,
  }
}

export const getNationalityDataSuccessful = user => {
 
  return {
    type: GET_NATIONALITY_SUCCESSFUL,
    payload: user,
  }
}

export const getNationalityDataFailed = user => {
  return {
    type: GET_NATIONALITY_FAILED,
    payload: user,
  }
}
//get country 
export const getCountries = user => {
  return {
    type: GET_COUNTRIES,
    payload: { user },
  }

}
export const setCountriesFailed = user => {
  return {
    type: GET_COUNTRIES_FAILED,
    payload: { user },
  }

}
export const setCountriesSuccess = user => {
  return {
    type: GET_COUNTRIES_SUCCESS,
    payload: { user },
  }

}
//get state
export const getState = user => {
  return {
    type: GET_STATE,
    payload: { user },
  }

}
export const setStateFailed = user => {
  return {
    type: GET_STATE_FAILED,
    payload: { user },
  }

}
export const setStateSuccess = user => {
  return {
    type: GET_STATE_SUCCESS,
    payload: { user },
  }

}
//GET COUNTRY AND STATE ON IP BASED FUNCTIONS
export const candidateGetIpBasedLocation = (iplocation) => {
  return {
    type: CANDIDATE_GET_IP_LOCATION,
    payload: {iplocation},
  }
}
export const candidateGetIpBasedLocationSuccess = (iplocation) => {
  return {
    type: CANDIDATE_GET_IP_LOCATION_SUCCESSFULL,
  payload: iplocation,
  }
}
export const candidateGetIpBasedLocationError = (iplocation) => {
  return {
    type: CANDIDATE_GET_IP_LOCATION_FAILED,
    payload: iplocation,
  }
}


//get state for permanent address
export const getPermanentState = user => {
  return {
    type: PERMANENT_GET_STATE,
    payload: { user },
  }

}
export const setPermanentStateFailed = user => {
  return {
    type: PERMANENT_GET_STATE_FAILED,
    payload: { user },
  }

}
export const setPermanentStateSuccess = user => {
  return {
    type: PERMANENT_GET_STATE_SUCCESS,
    payload: { user },
  }

}

//get state for qualification
export const getQualificationState = user => {
  return {
    type: GET_QUALIFICATION_STATE,
    payload: { user },
  }

}
export const setQualificationStateFailed = user => {
  return {
    type: GET_QUALIFICATION_STATE_FAILED,
    payload: { user },
  }

}
export const setQualificationStateSuccess = user => {
  return {
    type: GET_QUALIFICATION_STATE_SUCCESS,
    payload: { user },
  }

}


export const getStateAndCountryDetails = city => {
  return {
    type: GET_STATE_AND_COUNTRY_DETAILS,
    payload: { city },
  }
}

export const getStateAndCountryDetailsSuccessful = data => {
  return {
    type: GET_STATE_AND_COUNTRY_DETAILS_SUCCESS,
    payload: data,
  }
}

export const getStateAndCountryDetailsFailed = message => {
  return {
    type:GET_STATE_AND_COUNTRY_DETAILS_FAIL,
    payload: message,
  }
}


export const getSecondaryStateAndCountryDetails = city => {
  return {
    type: GET_SECONDARY_STATE_AND_COUNTRY_DETAILS,
    payload: { city },
  }
}

export const getSecondaryStateAndCountryDetailsSuccessful = data => {
  return {
    type: GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_SUCCESS,
    payload: data,
  }
}

export const getSecondaryStateAndCountryDetailsFailed = message => {
  return {
    type:GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_FAIL,
    payload: message,
  }
}
